module.exports = __webpack_public_path__ + "img/coupon_green.8d87d44b.webp";